import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { Spinner } from './components/States';
import { ForgotPasswordPage, LoginPage, RegisterPage, ResetPasswordPage } from './pages/Auth';
import {
  AccountPage,
  FavouritesPage,
  MyEnquiriesPage,
  NotFoundPage,
  PricingPage,
} from './pages/CustomerPages';
import { HomePage } from './pages/Home';
import { PropertyDetailPage } from './pages/PropertyDetail';
import { SearchResultsPage } from './pages/SearchResults';

/** Blocks a route until the session is known, then redirects if it does not qualify. */
function RequireAuth({ children }: { children: JSX.Element }) {
  const { initialising, isAuthenticated } = useAuth();
  const location = useLocation();

  if (initialising) {
    return (
      <div className="container py-5">
        <Spinner label="Checking your session" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />

          <Route path="pg" element={<SearchResultsPage category="PgHostel" />} />
          <Route path="homes" element={<SearchResultsPage category="HomeRental" />} />
          <Route path="hotels" element={<SearchResultsPage category="Hotel" />} />
          <Route path="listing/:slug" element={<PropertyDetailPage />} />
          <Route path="pricing" element={<PricingPage />} />

          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />

          <Route
            path="favourites"
            element={
              <RequireAuth>
                <FavouritesPage />
              </RequireAuth>
            }
          />
          <Route
            path="enquiries"
            element={
              <RequireAuth>
                <MyEnquiriesPage />
              </RequireAuth>
            }
          />
          <Route
            path="account"
            element={
              <RequireAuth>
                <AccountPage />
              </RequireAuth>
            }
          />


          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
